<template>
    <ul class="nav nav-tabs card-header-tabs">
        <li class="nav-item">
            <span class="nav-link cursor-pointer" :class="{'active': tab === 'articles'}"
                  @click="$emit('switch', 'articles')">
                <i class="fas fa-list mr-2"/>
                {{ __('general.articles') }}
            </span>
        </li>
        <li v-if="showAddressTab" class="nav-item">
            <span class="nav-link cursor-pointer" :class="{'active': tab === 'address'}"
                  @click="$emit('switch', 'address')">
                <i class="fas fa-user mr-2"/>
                {{ __('general.customer') }}
            </span>
        </li>
        <li v-if="showShipmentTab" class="nav-item">
            <span class="nav-link cursor-pointer" :class="{'active': tab === 'shipment'}"
                  @click="$emit('switch', 'shipment')">
                <i class="fas fa-truck mr-2"/>
                {{ __('general.shipment') }}
            </span>
        </li>
        <li v-if="showDocumentsTab" class="nav-item">
            <span class="nav-link cursor-pointer" :class="{'active': tab === 'documents'}"
                  @click="$emit('switch', 'documents')">
                <i class="fas fa-file-download mr-2"/>
                {{ __('general.documents') }}
            </span>
        </li>
        <li v-if="showPaymentsTab" class="nav-item">
            <span class="nav-link cursor-pointer" :class="{'active': tab === 'payment'}"
                  @click="$emit('switch', 'payment')">
                <i class="fas fa-money-bill mr-2"/>
                {{ __('general.payment') }}
            </span>
        </li>
        <li class="nav-item">
            <span class="nav-link cursor-pointer" :class="{'active': tab === 'refunds'}"
                  @click="$emit('switch', 'refunds')">
                <i class="fas fa-reply mr-2"/>
                {{ __('orders.returns') }}
            </span>
        </li>
        <li v-if="showPackagesTab" class="nav-item">
            <span class="nav-link cursor-pointer" :class="{'active': tab === 'packages'}"
                  @click="$emit('switch', 'packages')">
                <i class="fas fa-boxes mr-2"/>
                Packages
            </span>
        </li>
    </ul>
</template>

<script>
import {IntegrationCodeEnum} from "@generated/integrationCodeEnum";

export default {
    props: {
        tab: String,
        order: Object
    },

    computed: {
        IntegrationCodeEnum() {
            return IntegrationCodeEnum
        },

        showPackagesTab() {
            if (!this.order.integration.code !== IntegrationCodeEnum.AmazonTODAY) {
                return false;
            }

            if (this.order.state === 'pending') {
                return false;
            }
        },

        showShipmentTab(){
            return this.order.type === 'delivery' || (this.order.shipping_details !== null && this.order.shipping_details.length > 0)
        },

        showAddressTab() {
            return this.order.integration.code !== IntegrationCodeEnum.AmazonTODAY;
        },

        showPaymentsTab() {
            return this.order.integration.code !== IntegrationCodeEnum.AmazonTODAY;
        },

        showDocumentsTab() {
            return this.order.integration.code !== IntegrationCodeEnum.AmazonTODAY;
        }
    }
};
</script>
